const gender = [
  {code: '男',value: '1'},
  {code: '女',value: '2'},
]

export default gender;